// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card[data-v-35f57e0e]{padding-top:20px;background-color:#f5f5f5;width:80%;border-radius:10px;margin-inline:10%;box-shadow:0 4px 8px 0 rgba(0,0,0,.2);transition:.3s}.card[data-v-35f57e0e]:hover{box-shadow:0 8px 16px 0 rgba(0,0,0,.2)}table[data-v-35f57e0e]{text-align:left;width:100%}table tr[data-v-35f57e0e]{margin:5px;width:100%}.right[data-v-35f57e0e]{margin-left:10%;float:right}span[data-v-35f57e0e]{margin:5px}", ""]);
// Exports
module.exports = exports;
